
import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { BoosterVO } from "../../gamevo/BoosterVO";
import { IInventoryVO } from "../../gamevo/IInventoryVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { ShopVO } from "../../gamevo/ShopVO";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

const logger = getLogger("Poker2InventoryData");

export class Poker2InventoryData extends BasicData {
    protected _inventoryItems: IInventoryVO[];

    private _boosterItems: BoosterVO[];

    constructor() {
        super();
    }

    public parse_GIN(paramObject: any): void {
        if (paramObject)
            this.parseInventory(paramObject.I);

    }
    /**
     * Return the New-Inventory-Item Array
     */
    public parse_SBU(paramObject: any[]): void {
        if (paramObject) {
            if (paramObject != null) {
                for (let entryList of paramObject) {
                    var item: any = entryList;
                    if (item === undefined) continue;

                    var id: number = item.shift();
                    var colorID: number = item.shift();
                    // take fallback, if not defined. -1 stands for: not color available
                    colorID = (!isNaN(colorID)) ? colorID : -1;
                    var amount: number = 1;
                    this.addItem(id, colorID, amount);

                    var itemVO: ItemsVO = VOHelper.clone(Poker2Model.wodData.getItemVObyID(id)) as ItemsVO;

                    // sanity check
                    if (!itemVO) {
                        logger.error("parse_SBU(), itemVO is null due to unknown itemId: " + id);
                        return;
                    }

                    itemVO.colorId = colorID;
                    Poker2Model.avatarData.switchItem(itemVO, Poker2Model.avatarData.myAvatar, true);
                }
            }
        }

        this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_BUY);

        this.controller.dispatchEvent(new Poker2UserEvent("changeInventar"));
    }

    public parse_BBU(paramObject: any): void {
        if (!paramObject)
            return;
        var id: number = int(paramObject.id);
        var timeleft: number = paramObject.ti;
        var colorID: number = -1;
        var amount: number = 1;

        if (this.hasLowerBooster(id)) {
            var boosterToRemoveId: number = this.getLowerBoosterId(id);
            this.removeItem(boosterToRemoveId);
            this.addItem(id, colorID, amount, timeleft);
        } else if (this.hasItemByWodId(id)) {
            this.getInventoryItemById(id).timeleft = timeleft;
        } else if (!this.hasItemByWodId(id))
            this.addItem(id, colorID, amount, timeleft);

        this.updateBoosterItemsAry();

        this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_BUY);

        this.controller.dispatchEvent(new Poker2UserEvent("changeBooster"));
    }
    private parseInventory(paramArray: any[]): void {
        this._inventoryItems = [];
        if (paramArray.length < 1)
            return;

        if (paramArray != null) {
            for (let entryList of paramArray) {
                var item: any = entryList;
                if (item === undefined) continue;

                var id: number = int(item.shift());
                var colorID: number = int(item.shift());
                var amount: number = item.shift();
                var timeleft: number = item.shift();
                this.addItem(id, colorID, amount, timeleft);
            }
        }
        //BOOSTER HELPER
        this.updateBoosterItemsAry();
    }

    public addItem(id: number, colorId: number, amount: number = 1, timeleft: number = 0): void {
        var inventoryItem: IInventoryVO = castAs<IInventoryVO>(VOHelper.clone(Poker2Model.wodData.getItemVObyID(id)), "IInventoryVO");
        if (inventoryItem == null)
            return;
        inventoryItem.colorId = colorId;
        inventoryItem.inventoryAmount = amount;
        inventoryItem.timeleft = timeleft;
        this._inventoryItems.push(inventoryItem);

    }
    public removeItem(id: number): void {

        for (var i: number = 0; i < this._inventoryItems.length; i++) {
            if ((this._inventoryItems[i] as ItemsVO).id == id) {
                this._inventoryItems.splice(i, 1);
                return;
            }
        }
    }
    public getInventoryArray(): any[] {
        var result: any[] = new Array();
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;
                result.push(VOHelper.clone(itemtVO) as ShopVO);
            }
        }

        return result;
    }
    public getInventoryItemById(wodId: number): ShopVO {
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId)
                    return itemtVO;
            }
        }
        return null;
    }

    public getInventoryAmountByWodId(wodId: number): number {
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId)
                    return int(itemtVO.inventoryAmount);
            }
        }
        return 0;
    }

    public getInventoryColorIDsByWodId(wodId: number): any[] {
        var result: any[] = new Array();
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId && itemtVO.colorId >= 0)
                    result.push(itemtVO.colorId);
            }
        }
        return result;
    }

    public hasItemByWodIdAndColor(wodId: number, colorId: number): boolean {
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId && colorId == itemtVO.colorId)
                    return true;
            }
        }
        return false;
    }
    public hasItemByWodId(wodId: number): boolean {
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId)
                    return true;
            }
        }
        return false;
    }
    public hasBoosterByWodId(wodId: number): boolean {
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.id == wodId)
                    return true;
            }
        }
        return false;
    }

    public hasHigherBooster(wodId: number): boolean {
        var myBoosters: BoosterVO[] = this.boosterItems;
        var booster: BoosterVO = Poker2Model.wodData.getItemVObyID(wodId) as BoosterVO;

        if (booster.boostChips > 0) {
            for (var i: number = 0; i < myBoosters.length; i++) {
                var bChips: BoosterVO = myBoosters[i];
                if (bChips.boostChips > booster.boostChips && bChips.boostChips != 0)
                    return true;
            }
        } else if (booster.boostXP > 0) {
            for (var a: number = 0; i < myBoosters.length; i++) {
                var bXP: BoosterVO = myBoosters[i];
                if (bXP.boostXP > booster.boostXP && bXP.boostXP != 0)
                    return true;
            }
        }
        return false;
    }
    public getLowerBoosterId(wodId: number): number {
        var myBoosters: BoosterVO[] = this.boosterItems;
        var booster: BoosterVO = Poker2Model.wodData.getItemVObyID(wodId) as BoosterVO;

        if (booster.boostChips > 0) {
            for (var i: number = 0; i < myBoosters.length; i++) {
                var bChips: BoosterVO = myBoosters[i];
                if (bChips.boostChips < booster.boostChips && bChips.boostChips != 0)
                    return int(bChips.id);
            }
        } else if (booster.boostXP > 0) {
            for (var a: number = 0; i < myBoosters.length; i++) {
                var bXP: BoosterVO = myBoosters[i];
                if (bXP.boostXP < booster.boostXP && bXP.boostXP != 0)
                    return int(bXP.id);
            }
        }
        return 0;

    }

    public hasLowerBooster(wodId: number): boolean {
        var myBoosters: BoosterVO[] = this.boosterItems;
        var booster: BoosterVO = Poker2Model.wodData.getItemVObyID(wodId) as BoosterVO;

        if (booster.boostChips > 0) {
            for (var i: number = 0; i < myBoosters.length; i++) {
                var bChips: BoosterVO = myBoosters[i];
                if (bChips.boostChips < booster.boostChips && bChips.boostChips != 0)
                    return true;
            }
        } else if (booster.boostXP > 0) {
            for (var a: number = 0; i < myBoosters.length; i++) {
                var bXP: BoosterVO = myBoosters[i];
                if (bXP.boostXP < booster.boostXP && bXP.boostXP != 0)
                    return true;
            }
        }
        return false;
    }

    public getInventoryBySubCategory(shopCategorySecondary: string): any[] {
        var result: any[] = new Array();
        var dictResult: Map<any, any> = new Map<any, any>();
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var itemtVO: any = entryList;
                if (itemtVO === undefined) continue;

                if (itemtVO.shopCategorySecondary == shopCategorySecondary)
                    dictResult.set(itemtVO.id, VOHelper.clone(itemtVO) as ShopVO);
            }
        }
        if (dictResult != null) {
            for (let entryList of Array.from(dictResult.values())) { var resultItemVO: any = entryList; result.push(resultItemVO); }
        }
        return result;
    }
    private updateBoosterItemsAry(): void {
        this.boosterItems = [];
        var dictResult: Map<any, any> = new Map<any, any>();
        if (this._inventoryItems != null) {
            for (let entryList of this._inventoryItems) {
                var boosterVO: any = entryList;
                if (boosterVO === undefined) continue;

                if (boosterVO.shopCategoryMain == "booster")
                    dictResult.set(boosterVO.id, VOHelper.clone(boosterVO) as ShopVO);
            }
        }
        if (dictResult != null) {
            for (let entryList of Array.from(dictResult.values())) {
                var resultItemVO: any = entryList;
                if (resultItemVO === undefined) { continue; }

                this.boosterItems.push(resultItemVO);
            }
        }
    }

    public get boosterItems(): BoosterVO[] {
        return this._boosterItems;
    }

    public set boosterItems(value: BoosterVO[]) {
        this._boosterItems = value;
    }
}

import { castAs } from "@goodgamestudios/createjs-utilities";
